export default [
  // 电子码单(仓库销售单)
  {
    path: '/demand/info',
    name: 'DemandInfo',
    component: () => import(/* webpackChunkName: 'DemandInfo' */ '@/views/demand/info'),
  },
];
